import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Approval } from 'app/models/dto/approval/approval.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { IApprovalPublishResponse, IApprovalRecommendResponse } from './approvals.interface';
import { DeclineReason } from 'ng2-app/models/dto/decline-reason.model';

@Injectable({
  providedIn: 'root'
})
export class ApprovalsService {

  constructor(private http: ApiHttpClient) { }


  getApprovalsByBorrowerId(borrowerId: number): Observable<Approval[]> {
    return this.http.get<Approval[]>(`${environment.API_URL}/approval/borrower/${borrowerId}?all=true`);
  }

  getApprovalsCountByBorrowerId(borrowerId: number): Observable<any> {
    return this.http.get<Approval[]>(`${environment.API_URL}/approval/borrower/${borrowerId}/count`);
  }

  getApprovalsByDealId(dealId: number): Observable<Approval[]> {
    return this.http.get<Approval[]>(`${environment.API_URL}/approval/deal/${dealId}`);
  }

  getApprovalsCountByDealId(dealId: number): Observable<any> {
    return this.http.get<Approval[]>(`${environment.API_URL}/approval/deal/${dealId}/count`);
  }

  getAdjustedApproval(approvalId: number,
    amount: number,
    term: number,
    points: number,
    frequency: string,
    origination: number): Observable<any> {
    return this.http.get(`${environment.API_URL}/approval/${approvalId}/adjustments?
      amount=${amount}&term=${term}&points=${points}&frequency=${frequency}&origination=${origination}`);
  }

  publishApproval(approvalId): Observable<IApprovalPublishResponse> {
    return this.http.post<IApprovalPublishResponse>(`${environment.API_URL}/approval/${approvalId}/publish`, {});
  }
  unpublishApproval(approvalId): Observable<IApprovalPublishResponse> {
    return this.http.post<IApprovalPublishResponse>(`${environment.API_URL}/approval/${approvalId}/unpublish`, {});
  }

  attachValuePropositions(approvalId: number, valuePropositionIds: number[]) {
    return this.http.put<Approval>(`${environment.API_URL}/approval/${approvalId}/value-propositions`, {
      valuePropositionIds,
    });
  }

  attachedDeclineReasons(approvalId: number, declineReasons: Pick<DeclineReason, 'id' | 'comment'>[]) {
    return this.http.put<Approval>(`${environment.API_URL}/approval/${approvalId}/decline`, {
      declineReasons,
    });
  }

  recommendApproval(approvalId: number, recommend: boolean): Observable<IApprovalRecommendResponse> {
    return this.http.post<IApprovalRecommendResponse>(`${environment.API_URL}/approval/${approvalId}/recommend`, {
      recommend,
    });
  }
}
